import React from "react";
import "./Terms.css";

const TermsOfService = () => {
  return (
    <section className="legal-container">
      <div className="legal-wrapper">
        <h1 className="legal-title">Terms of Service</h1>
        <p className="legal-date">Last Updated: February 2026</p>

        <p>
          By accessing or using Teckpik services, you agree to these Terms of
          Service.
        </p>

        <h2>1. Services</h2>
        <p>
          Teckpik provides web development, Mobile App development, digital
          marketing, graphic design, Print on Demand and photography services
          under agreed project terms.
        </p>

        <h2>2. Acceptable Use</h2>
        <ul>
          <li>Use the website for lawful purposes only</li>
          <li>No unauthorized access or malicious activity</li>
        </ul>

        <h2>3. Intellectual Property</h2>
        <p>
          All website content is the property of Teckpik unless stated
          otherwise.
        </p>

        <h2>4. Payments</h2>
        <p>
          Payment terms are defined per project. Payments are non-refundable
          once work has started.
        </p>

        <h2>5. Limitation of Liability</h2>
        <p>
          Teckpik is not liable for indirect or consequential damages resulting
          from service use.
        </p>

        <h2>6. Governing Law</h2>
        <p>These terms are governed by the laws of Pakistan.</p>
      </div>
    </section>
  );
};

export default TermsOfService;
